import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setupNavigation } from "../../../redux/actions/navItemsActions"
import { loadUserProfile } from "../../../redux/actions/userActions"
import SecuritySettingsForm from "./SecuritySettingsForm"
import { changePassword } from "../../../redux/actions/authActions"
import Spinner from "../../common/Spinner";
import { toast } from "react-toastify";
import EditProfileBanner from "./EditProfileBanner";

function SecuritySettingsPage({
    user,
    setupNavigation,
    loadUserProfile,
    settings,
    changePassword,
    history,
    ...props
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(true);
    const [passwordDetails, setPasswordDetails] = useState({ ...props.passwordDetails });
    const [settingDetails, setSettingDetails] = useState({
        firstName: "",
        surname: "",
        email: "",
        location: "",
        preferredMeasurementUnits: "0",
        subscribedMarketingNotification: false,
        subscribedRideBlogsNotification: false,
        approveFollowers: false,
        avatar: { src: "", preview: "" }
    });
    const navigationItems =
    {
        sections: [
            {
                name: 'Settings',
                showTitle: true,
                items: [
                    {
                        path: '/user/settings/general',
                        text: 'General Settings',
                        icon: 'fas fa-tasks'
                    },
                    {
                        path: '/user/settings/site',
                        text: 'Site Settings',
                        icon: 'fas fa-cogs'
                    },
                    {
                        path: '/user/settings/security',
                        text: 'Security',
                        icon: 'fas fa-key'
                    },
                    {
                        path: '/user/settings/garmin',
                        text: 'Garmin Connect',
                        icon: 'fas fa-mobile-android-alt'
                    },
                    {
                        path: '/user/settings/closeaccount',
                        text: 'Close Account',
                        icon: 'fas fa-user-times'
                    }
                ]
            }
        ]
    };

    useEffect(() => {
        document.title = "User Settings | JustGoRide";
        setupNavigation(navigationItems);
        if (!user || !user.id) {
            history.push("/login");
        }
        if (!settings.email) {
            setProcessing(true);
            loadUserProfile(user.id)
                .then((s) => {
                    s.avatarDetails = { src: "", preview: s.avatar }
                    setSettingDetails(s);
                    setProcessing(false);
                })
        }
        else {
            settings.avatarDetails = { src: "", preview: settings.avatar }
            setSettingDetails(settings);
            setProcessing(false);
        }
    }, []);

    function handlePasswordChange(event) {
        const { name, value } = event.target;
        setPasswordDetails(prevPasswordDetails => ({
            ...prevPasswordDetails,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: undefined
        }));
    }

    function passwordFormIsValid() {
        const errors = {};
        var isValid = true;

        if (!passwordDetails.currentPassword) {
            errors.currentPassword = "You provide your current password.";
            setErrors(errors);
            isValid = false;
        }

        if (!passwordDetails.newPassword) {
            errors.newPassword = "You must specify a new password.";
            setErrors(errors);
            isValid = false;
        }

        if (!passwordDetails.newPasswordConfirmation) {
            errors.newPasswordConfirmation = "You must confirm the password.";
            setErrors(errors);
            isValid = false;
        }

        if (passwordDetails.newPassword !== passwordDetails.newPasswordConfirmation) {
            errors.newPasswordConfirmation = "The passwords must match.";
            setErrors(errors);
            isValid = false;
        }

        var passwordStrength = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        if (!passwordStrength.test(passwordDetails.newPassword)) {
            errors.newPassword = "Password must be at least 8 charactors in length, contain upper and lowecase letters and at least one number.";
            setErrors(errors);
            isValid = false;
        }
        return isValid;
    }

    function handlePasswordSave(event) {
        event.preventDefault();

        if (!passwordFormIsValid()) return;
        setProcessing(true);
        changePassword(passwordDetails).then(() => {
            toast.success("Password changed");
            setErrors({});
            setProcessing(false);
        })
            .catch(error => {
                setProcessing(false);
                setErrors({ onPasswordSave: error.message });
            });
    }

    return (
        processing ?
            <Spinner /> :
            <React.Fragment>
                <EditProfileBanner title="Security Settings" />
                <div className="settings-container row justify-content-md-center pb-5">
                    <SecuritySettingsForm
                        passwordDetails={passwordDetails}
                        errors={errors}
                        onChange={handlePasswordChange}
                        onChangePassword={handlePasswordSave}
                        processing={processing}
                    />
                </div>
            </React.Fragment>
    );

}



SecuritySettingsPage.propTypes =
{
    setupNavigation: PropTypes.func.isRequired,
    loadUserProfile: PropTypes.func.isRequired,
    settings: PropTypes.object.isRequired,
    passwordDetails: PropTypes.object.isRequired,
    changePassword: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    errorMessage: PropTypes.string
}


function mapStateToProps(state) {
    return {
        passwordDetails: { currentPassword: "", newPassword: "", newPasswordConfirmation: "" },
        settings: state.settings,
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation,
    loadUserProfile,
    changePassword
}

export default connect(mapStateToProps, mapDispatchToProps)(SecuritySettingsPage);






// WEBPACK FOOTER //
// ./src/components/user/settings/SecuritySettingsPage.js